import useClickAway from 'registry/components/useClickAway/useClickAway'
import {
  // eslint-disable-next-line no-restricted-imports
  DropdownButton as RBDropdownButton,
  DropdownButtonProps as RBDropdownButtonProps,
} from 'react-bootstrap'
import { useContext, useLayoutEffect } from 'react'
import { useWindowSize } from 'lib/hooks'
import { MessageCenterContext } from '../MessageCenter/contexts'

type MessageCenterDropdownButtonProps = RBDropdownButtonProps & {
  onClickAway: () => unknown
}

const MAX_MOBILE_SCREEN_WIDTH = 450

const MessageCenterDropdownButton = ({
  onClickAway,
  onSelect,
  ...rest
}: MessageCenterDropdownButtonProps) => {
  const clickAwayRef = useClickAway<HTMLDivElement>(() => onClickAway?.())
  const { isOpen } = useContext(MessageCenterContext)
  const { height: windowHeight, width: windowWidth } = useWindowSize()

  useLayoutEffect(() => {
    if (clickAwayRef.current && windowHeight && windowWidth && isOpen) {
      const menu = clickAwayRef.current.querySelector('ul')
      if (menu && windowWidth < MAX_MOBILE_SCREEN_WIDTH) {
        const menuPositionFromTop = menu.getBoundingClientRect().top
        let height = windowHeight - menuPositionFromTop

        // ensure the mobile tab bar doesn't block the inbox
        const mobileTabBar: HTMLDivElement | null = document.querySelector(
          '[data-react-class="MobileTabBar"] > div'
        )

        if (mobileTabBar) {
          height -= mobileTabBar.offsetHeight
        }

        menu.style.height = `${height}px`
      } else if (menu) {
        menu.style.height = ''
      }
    }
  }, [clickAwayRef.current, windowHeight, windowWidth, isOpen])

  return (
    <div ref={clickAwayRef}>
      <RBDropdownButton
        open={isOpen}
        onSelect={(e) => onSelect?.(e)}
        {...rest}
      />
    </div>
  )
}

export default MessageCenterDropdownButton
